import React, { useState } from 'react';
import { ServiceList } from 'containers';
import { Select } from 'components/Form';
// import useObservable from 'inc/hooks/useObservable';
import TableList from 'components/List/TableList';
import ServicePaginationList from 'components/ServiceList';
import moment from 'moment';

type Props = {
  onFileSelect?: (file: Data) => void,
}

const BrandList = ({ onFileSelect }: Props) => {
  // const company = useObservable('company');
  const condition = [];
  const [filters, setFilters] = useState({
    company: '', brand: '',
  });
  filters.company && condition.push({ field: 'company', value: filters.company });
  return (
    <>
      <ServiceList
        component={(items, loading) =>
          <Select
            disabled={loading}
            label="Company"
            name="__company"
            onChange={(e: Data) => setFilters(filters => ({...filters, company: e.target.value}))}
            options={items}
            style={{ marginRight: 10 }}
          />
        }
        path="companies"
        waitForLoad={false}
      />
      <ServicePaginationList
        Component={TableList}
        componentProps={{
          actions: [
            {
              callback: onFileSelect,
              label: 'Select',
            }
          ],
          fields: [
            {
              id: 'name',
              label: 'Title',
              sortable: true,
              width: '55%',
            },
            {
              id: 'updated.on',
              label: 'Updated',
              prepare: (value: number) => {
                return value ? moment.unix(value / 1000).format('MM/DD/YYYY HH:mm') : '';
              },
              sortable: true,
            },
          ],
        }}
        condition={condition}
        path="brands"
      />
    </>
  );
};

export default BrandList;
